import { useQuery } from '@tanstack/react-query';
import { LIST_BADGE_LIFECYCLE_STATE } from '@terra/shared-dto-types';
import { terraProxyApiClient } from '../../clients/testerClient';
import { toFindingSeverityCounts } from '../../components/dashboard/posture-items';

export function useFindingsSeverityCounts(applicationId: string) {
  return useQuery({
    queryKey: ['findings-severity-counts', applicationId],
    queryFn: () =>
      terraProxyApiClient.countFindingsGroupsByFilter({
        payload: {
          applicationId,
          filter: { lifecycleState: LIST_BADGE_LIFECYCLE_STATE },
        },
        groupBy: 'severity',
      }),
    select: toFindingSeverityCounts,
    enabled: !!applicationId,
    staleTime: 30_000,
  });
}
